import { render, staticRenderFns } from "./DashboardIndicadores.vue?vue&type=template&id=751e9e24&scoped=true"
import script from "./DashboardIndicadores.vue?vue&type=script&lang=js"
export * from "./DashboardIndicadores.vue?vue&type=script&lang=js"
import style0 from "./DashboardIndicadores.vue?vue&type=style&index=0&id=751e9e24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751e9e24",
  null
  
)

export default component.exports